module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-6.57485543.jpg";